var map = {
	"./Icon_About.svg": 76302,
	"./Icon_Additional-resources.svg": 41424,
	"./Icon_Additional-resources_w.svg": 49210,
	"./Icon_Calls.svg": 68342,
	"./Icon_Calls_w.svg": 92952,
	"./Icon_Combination-funding.svg": 9948,
	"./Icon_Combination-funding_w.svg": 91494,
	"./Icon_Company.svg": 34800,
	"./Icon_Connections.svg": 38654,
	"./Icon_Cup.svg": 27345,
	"./Icon_Description.svg": 46231,
	"./Icon_Description_w.svg": 56033,
	"./Icon_Economic-sector.svg": 34939,
	"./Icon_Expert.svg": 81975,
	"./Icon_Filters.svg": 40088,
	"./Icon_Founding.svg": 79599,
	"./Icon_Info.jpg": 19987,
	"./Icon_Info.svg": 16107,
	"./Icon_Info_2.svg": 60488,
	"./Icon_Info_w.svg": 32533,
	"./Icon_Innovation-programme.svg": 4651,
	"./Icon_Innovation.svg": 51426,
	"./Icon_Link.svg": 21879,
	"./Icon_Magnifying-lens.svg": 41998,
	"./Icon_More-info.svg": 97989,
	"./Icon_More-info_w.svg": 39191,
	"./Icon_Print-2.svg": 13465,
	"./Icon_Project.svg": 49854,
	"./Icon_Project_w.svg": 20880,
	"./Icon_Relevance.svg": 20708,
	"./Icon_Relevance_w.svg": 22878,
	"./Icon_Startup-village.svg": 91397,
	"./Icon_Tips.svg": 75573,
	"./Icon_Who.svg": 66265,
	"./Icon_Who_w.svg": 61115,
	"./Icon_Yes.svg": 4788,
	"./IconsSVF/Icon_About.svg": 75628,
	"./IconsSVF/Icon_Connections.svg": 2348,
	"./IconsSVF/Icon_Economic-sector.svg": 92069,
	"./IconsSVF/Icon_Founding.svg": 96269,
	"./IconsSVF/Icon_Innovation-programme.svg": 64477,
	"./IconsSVF/Icon_Innovation.svg": 36596,
	"./IconsSVF/Icon_Startup-village.svg": 86859,
	"./IconsSVF/Icon_Yes.svg": 69742,
	"./RT-asset_About-1.svg": 58114,
	"./RT-asset_About-2.svg": 78481,
	"./RT-asset_About-3.svg": 42528,
	"./RT-asset_FAQ.svg": 66311,
	"./RT-asset_v2_Financial-instruments.svg": 47672,
	"./RT-asset_v2_Funding-finder.svg": 67320,
	"./RT-asset_v2_Funds-authority.svg": 20556,
	"./RT-asset_v2_Funds-direct-access.svg": 43261,
	"./RT-asset_v2_Inspire-youreself.svg": 96989,
	"./RT-asset_v2_Resources.svg": 915,
	"./icon_events.svg": 57200,
	"./icon_hb2020.svg": 68065,
	"./icon_hb2022.svg": 17315,
	"./icon_jrc_reports.svg": 96238,
	"./icon_news.svg": 2062,
	"./icon_publications.svg": 13602,
	"./ltvra_C_icon.svg": 65302,
	"./ltvra_P_icon.svg": 91135,
	"./ltvra_R_icon.svg": 33485,
	"./ltvra_S_icon.svg": 53638,
	"./test.svg": 10387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25853;